module.exports = __webpack_public_path__ + "img/mourning-dove.d38b4d25.jpg";